import {
  Box,
  Button,
  Center,
  Flex,
  Loader,
  Paper,
  Table,
  Text,
  Title,
  createStyles,
} from "@mantine/core";
import { formatDateTime } from "@medplum/core";
import { useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { filterByValueString, getAccessToken, pushToEpicHandler } from "../../../utils";
import { useSelector } from "react-redux";
import { AppState } from "../../../store/types/appState";
import { showNotification } from "@mantine/notifications";
import GenericInfoModal from "../../../components/GenericInfoModal";
import dbStoringIcon from "../../../assets/img/storingDBLogo.svg";
import fetchResourceIcon from "../../../assets/img/fetchingResourceLogo.svg";
import { IAccumulator } from "../../Appointment/AppointmentModal";
import { useDispatch } from "react-redux";
import { Condition } from "./Condition";
// import { findEpicPractitionerExtension,  } from "./Service";

const useStyles = createStyles((theme) => ({
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
}));

export const AllergyIntolerance = () => {
  const { patientId } = useParams();
  const { classes } = useStyles();
  const dispatch = useDispatch();
 

  const medplum = useMedplum();
   const profile = medplum.getProfile();
  //  const clientId = findEpicPractitionerExtension(profile);
  const [epicId, setEpicId] = useState<any>("");
    // const [clientId, setClientId] = useState<any>();

  const [allergies, setAllergies] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
      const [showInfoModal, setShowModal] = useState(false);
 const [succesMessage, setSuccessMessage] = useState(
   "Storing in EPIC EHR"
 );

 const [modalData, setModalData] = useState({
   title: "",
   sideTitle: "",
   details: [] as any,
   confirmText: "",
   onClose: () => {},
   onConfirm: () => {},
 });
   const modalSteps = [
     {
       loadText: "Creating AllergyIntolerance in EPIC EHR",

       label: "Creating AllergyIntolerance in EPIC EHR",

       icon: fetchResourceIcon,
     },
     {
       loadText: "AllergyIntolerance created successfully",
       label: "AllergyIntolerance created successfully",
       icon: fetchResourceIcon,
     },
     {
       loadText: succesMessage,
       label: succesMessage,
       icon: dbStoringIcon,
     },
   ];
   
 
  const logginedUser = useSelector((state: AppState) => state) as any;

  const epicDataFromExtension = filterByValueString(
    logginedUser?.app?.profile?.extension || ([] as any),
    "epic"
  );

 
  useEffect(() => {
   
    getAllergyIntolerances();
    getPatientDetails().then((response: any) => {
      const fhirStu3Value = response[0]?.identifier.find(
        (identifier: any) => identifier?.type?.text === "FHIR STU3"
      )?.value;
      setEpicId(fhirStu3Value);
    });
  }, [patientId]);
 
  const clientId =
    epicDataFromExtension[epicDataFromExtension?.length - 1]?.url?.split(
      "/"
    )?.[1];

  const payload = {
    request: "createResource",
    patientId: patientId,
    clientId: clientId,
    requestParams: {
      resourceType: "AllergyIntolerance",
      resource: allergies[0],
    },
    oauthData: {
      accessToken:
        epicDataFromExtension[epicDataFromExtension?.length - 1]?.extension?.[0]
          ?.valueString || "",
    },
  };

  const pushAllergiesToEpic = () => {
   
    updatePayloadForEpic();
          const activeLogin = getAccessToken();
          

    try {
         if(!epicId){
     showNotification({
       color: "red",
       message: `Select Epic Patient`,
       autoClose: true,
     });
     return
  }
          setShowModal(true);
            const result: IAccumulator = epicDataFromExtension[
              epicDataFromExtension?.length - 1
            ]?.extension?.reduce((acc: IAccumulator, { url, valueString }) => {
              if (url === "refresh_token") {
                acc.refreshToken = valueString;
              } else if (url === "integrationType") {
                acc.integrationType = valueString;
              } else if (url === "display") {
                acc.name = valueString;
              }
              return acc;
            }, {});
             
            const metaData = {
              dispatch,
              clientId: clientId,
              integrationType: result?.integrationType,
              refreshToken: result?.refreshToken,
              activeLogin,
              name: result.name,
            };
          setModalData({
            title:
              " Please wait, we are creating AllergyIntolerance Resource in EPIC EHR",
            sideTitle: "",
            details: [
              { label: "Title", text: "" },
              { label: "Description", text: "" },
            ],
            confirmText: "Proceed",
            onClose: () => {
              setShowModal(false);
            },
            onConfirm: async () => {
              await pushToEpicHandler(medplum, payload,metaData).then((res) => {
                if (res) {
                 if (res?.body?.error?.includes("duplicate")) {
                   showNotification({
                     color: "red",
                     message: "Record already exists in Epic",
                     autoClose: true,
                   });
                 }
                 if (res?.status === 201) {
                   showNotification({
                     color: "green",
                     message: "Record successfully pushed to Epic",
                     autoClose: true,
                   });
                 }else{
                   showNotification({
                     color: "red",
                     message: "Please try again",
                     autoClose: true,
                   });
                 }
                } else {
                  setSuccessMessage("Failed ,Please try again");
                  showNotification({
                    color: "red",
                    message: "Please try again",
                    autoClose: true,
                  });
                }
              });
            },
          });
  
     
    } catch (error) {
      console.log(error);
      showNotification({
        color: "red",
        message: `Failed ${error} `,
        autoClose: true,
      });
    }
  };

  const getPatientDetails = () => {
    return medplum.searchResources("Patient", { _id: patientId });
  };

  const getAllergyIntolerances = async () => {
    const res = await medplum.searchResources(
      "AllergyIntolerance",
      `patient=Patient/${patientId}`
    );
    setAllergies(res);
    setIsFetching(false);
  };

  const updatePayloadForEpic = () => {
    allergies[0].patient.reference = `Patient/${epicId}`;
    delete allergies[0]?.meta;
    delete allergies[0]?.id;
     allergies[0].verificationStatus.coding[0].code = "unconfirmed";

  };

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "0px",
          marginRight: "0px",
          padding: "20px",
          background: "#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        withBorder
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Title>Allergies</Title>
          <Button disabled={!allergies[0]} onClick={pushAllergiesToEpic}>Push To Epic</Button>
        </Box>

        <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              <th>Allergy/Intolerance</th>
              <th>Recorded Date</th>
              <th>Clinical Status</th>
              <th>Verification Status</th>
              <th>Criticality</th>
            </tr>
          </thead>
          <tbody>
            {allergies.map((data: any) => (
              <tr key={data.id}>
                <td>{data.code.text}</td>
                <td>{formatDateTime(data.recordedDate as string)}</td>
                <td>{data.clinicalStatus.coding[0]?.display || "Unknown"}</td>
                <td>
                  {data.verificationStatus.coding[0]?.display || "Unknown"}
                </td>
                <td>{data.criticality}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        {allergies?.length === 0 && !isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        )}
      </Paper>
      {showInfoModal && (
        <GenericInfoModal
          isOpen={showInfoModal}
          steps={modalSteps}
          modalData={modalData}
          onClose={modalData.onClose}
          onConfirm={modalData.onConfirm}
          setIsPatientModalOpen={setShowModal}
          showStepsImmediately={true}
          autoConfirm={true}
        />
      )}
    </>
  );
};
